import Plausible from 'plausible-tracker';

const plausible = Plausible({
  domain: import.meta.env.REACT_APP_PLAUSIBLE_DOMAIN || 'racetrainer.ai',
  trackLocalhost: true,
});

plausible.enableAutoPageviews();

export default plausible;
